/**
 * en-GB messages added by shared reception task C-SR1 (docs/SHARED-RECEPTION-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts. UK English only.
 */
export const cSr1EnGB = {};
//# sourceMappingURL=c-sr1.js.map